module.exports = __webpack_public_path__ + "static/img/安诚保险.3635a73.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/安诚保险.png
// module id = RLjl
// module chunks = 0 1 2 9